export const REQUIREMENT_CATEGORY = {
    DOC_UPLOAD: '1',
    DOC_REVIEW: '2',
    COURSE: '3'
}

export const USER_DEACTIVATE_FILTER = "Admin";